import React from 'react'

import type { Category } from 'containers/GamesBlock/types'

import { GamesGrid } from './GamesGrid'
import { Header } from './Header'

export function GamesCategory({ category }: { category: Category }) {
  const { rows, games } = category
  return (
    <>
      <Header category={category} />
      <GamesGrid
        rows={rows}
        gameSlugs={games}
      />
    </>
  )
}
